export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    month = "",
    year = "",
    rows = [],
    totalOpeningDebit = 0,
    totalOpeningCredit = 0,
    totalDebitAmount = 0,
    totalCreditAmount = 0,
    totalClosingDebit = 0,
    totalClosingCredit = 0,
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const tableRows = rows.map((row) => `
    <tr>
      <td class="border text-center">${row.accountCode || ""}</td>
      <td class="border px-1">${row.accountName || ""}</td>
      <td class="border text-right px-1">${fmt(row.openingDebit)}</td>
      <td class="border text-right px-1">${fmt(row.openingCredit)}</td>
      <td class="border text-right px-1">${fmt(row.debitAmount)}</td>
      <td class="border text-right px-1">${fmt(row.creditAmount)}</td>
      <td class="border text-right px-1">${fmt(row.closingDebit)}</td>
      <td class="border text-right px-1">${fmt(row.closingCredit)}</td>
    </tr>
  `).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 13px; color: black; line-height: 1.5;">
      <table width="100%">
        <tr>
          <td width="40%" valign="top">
            <div class="font-bold">Đơn vị: <span class="dotted-line">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span class="dotted-line">${address}</span></div>
          </td>
          <td width="60%" align="center">
            <div class="font-bold">Mẫu số S06-DN</div>
            <div style="font-style: italic; font-size: 12px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 20px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 17px;">BẢNG CÂN ĐỐI SỐ PHÁT SINH</h2>
        <div style="margin-top: 8px; font-weight: bold;">Tháng ${month}... năm ${year}...</div>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 10px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="80">Số hiệu tài khoản</th>
            <th class="border" rowspan="2">Tên tài khoản kế toán</th>
            <th class="border" colspan="2">Số dư đầu tháng</th>
            <th class="border" colspan="2">Số phát sinh trong tháng</th>
            <th class="border" colspan="2">Số dư cuối tháng</th>
          </tr>
          <tr>
            <th class="border" width="100">Nợ</th>
            <th class="border" width="100">Có</th>
            <th class="border" width="100">Nợ</th>
            <th class="border" width="100">Có</th>
            <th class="border" width="100">Nợ</th>
            <th class="border" width="100">Có</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">4</th>
            <th class="border">5</th>
            <th class="border">6</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
          <tr style="font-weight: bold; background-color: #fafafa;">
            <td class="border"></td>
            <td class="border px-1">Tổng cộng</td>
            <td class="border text-right px-1">${fmt(totalOpeningDebit)}</td>
            <td class="border text-right px-1">${fmt(totalOpeningCredit)}</td>
            <td class="border text-right px-1">${fmt(totalDebitAmount)}</td>
            <td class="border text-right px-1">${fmt(totalCreditAmount)}</td>
            <td class="border text-right px-1">${fmt(totalClosingDebit)}</td>
            <td class="border text-right px-1">${fmt(totalClosingCredit)}</td>
          </tr>
        </tbody>
      </table>

      <table width="100%" style="margin-top: 30px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 12px; margin-bottom: 5px;">Ngày ${signingDay}..... tháng ${signingMonth}.... năm ${signingYear}....</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 60px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 6px; }
        .dotted-line { border-bottom: 1px dotted black; }
      </style>
    </div>
  `;
};
